import { graphql, useStaticQuery } from "gatsby";
import { useState } from "react";
import VideoModal from "../../atoms/video-modal/VideoModal";
import "./VideosAbout.scss";

// @ts-ignore
import iconArrowR from "../../../assets/icons/CDA/icon_flecha_blanca.svg";

const VideosAbout = ({
  hideMobile = false,
  thinMode = false,
}: {
  hideMobile?: boolean;
  thinMode?: boolean;
}) => {
  const data = useStaticQuery(graphql`
    query GET_CDA_TE_ACOMPANAMOS {
      allContentfulTemplate(filter: { nombre: { eq: "Te acompañamos" } }) {
        nodes {
          h2
          h3
          referencias {
            h2
            span
            image {
              title
              file {
                url
              }
            }
          }
          button {
            copy
            copy2
            url
            icono {
              file {
                url
              }
            }
          }
        }
      }
    }
  `).allContentfulTemplate.nodes[0];

  const [showVideo, setShowVideo] = useState(false);

  const handleToggleVideo = () => {
    document.body.classList.toggle("noscroll", showVideo);
    setShowVideo(prev => !prev);
  };

  const buildClassName = (baseName: string) =>
    `gtmTeacompañamos${baseName?.replace(/\s/g, "")}`;

  return (
    <div
      className={`m-videos-about-container ${hideMobile ? "hide_mobile" : ""} ${
        thinMode ? "thin_mode" : ""
      }`}
    >
      <div className="m-videos-about">
        <div className="m-videos-about__title-box">
          <h2>{data.h2}</h2>
          <p>{data.h3}</p>
        </div>
        <div className="m-box-containers">
          <div
            tabIndex={0}
            role="button"
            aria-label={`Botón para abrir video de ${data.referencias[0].h2}`}
            className={`a-box-video ${buildClassName(data.referencias[0].h2)}`}
            onClick={handleToggleVideo}
            style={{
              backgroundImage: `url(${data.referencias[0].image[0].file.url})`,
            }}
          >
            <i className="icon-play-circle" />
            <p>{data.referencias[0].h2}</p>
          </div>
          <a
            aria-label={`Enlace a ${data.button[0].copy} ${data.button[0].copy2}`}
            className={`a-box-reference ${buildClassName(data.button[0].copy)}`}
            href={data.button[0].url}
            style={{
              backgroundImage: `url(${data.button[0].icono.file.url})`,
            }}
          >
            <p>{data.button[0].copy2}</p>
            <img src={iconArrowR} alt="ícono de ir a la página" />
          </a>
          {showVideo && (
            <VideoModal
              linkID={data.referencias[0].span}
              closeVideoModal={handleToggleVideo}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VideosAbout;
